export default __webpack_public_path__ + "static/media/crop-repairmen-working-with-tablet-min-min.aced7f1f.jpg";